'use client';

import { locales } from '@/i18n/locale-config';
import { usePathname, useRouter } from '@/i18n/navigation';
import { cn } from '@/utils/tailwind-merge';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { Fragment } from 'react';

const LanguageSwitcher = ({ className }: { className?: string }) => {
    const currentLocale = useLocale();
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const handleChangeLocale = (locale: 'fr' | 'en' | undefined) => {
        const params = new URLSearchParams(searchParams.toString());
        router.replace({ pathname, query: Object.fromEntries(params) }, { locale });
    };

    return (
        <div className={cn('flex gap-2.5', className)}>
            {locales.map((locale) => (
                <Fragment key={locale}>
                    <button
                        onClick={() => handleChangeLocale(locale)}
                        className={`text-[22px] md:text-[28px] leading-4 uppercase transition-colors duration-300 ${currentLocale === locale ? 'text-pink-light' : 'text-gray-100 hover:text-gray-200'}`}
                    >
                        {locale}
                    </button>
                    {locale !== locales[locales.length - 1] && (
                        <span className="text-[28px] leading-4 uppercase text-gray-100">/</span>
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export default LanguageSwitcher;
